import React from "react";

const ProjectList = () => {
    return (
        <div>
            <h1>Project List</h1>
        </div>
    );
};

export default ProjectList;
